import { action } from 'typesafe-actions';
import { PaymentOption } from '../../library/interfaces';
import { SET_LAST_DEPOSIT } from './constants';

export const setLastDeposit = (deposit_amount: number, funding_source: PaymentOption | null) =>
  action(SET_LAST_DEPOSIT, { deposit_amount, funding_source });
